import React from "react";
import ContentForm from "../../UI/ContentForm/ContentForm";
import Button from "../../UI/Button/Button";
import Select from "../../UI/Select/Select";
import Input from "../../UI/Input/Input";
import Fade from "react-reveal/Fade";
import "./UnitForm.css";
import {
  checkValidity,
  IsIRNationalCodeValid,
  IsLegalNationalCodeValid,
  updateObject,
} from "../../../shared/utility";
import FetchData from "../../../shared/fetchData";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const UnitForm = (props) => {
  const [parents, setParents] = React.useState(props.units);
  const [parent, setParent] = React.useState("");
  const [edit, setEdit] = React.useState(props.edit);
  const [loading, setLoading] = React.useState(false);
  const [id, setId] = React.useState("");
  const [changeForm, setChangeForm] = React.useState(false);
  const [invalidSelect, setInvalidSelect] = React.useState(false);
  const [enableFirstMile, setEnableFirstMile] = React.useState(false);
  const [enableLastMile, setEnableLastMile] = React.useState(false);
  const [unit, setUnit] = React.useState({
    unitName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    economicalNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره اقتصادی",
      },
      validation: {
        required: true,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    registrationNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره ثبت",
      },
      validation: {
        required: true,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "کد پستی",
      },
      validation: {
        required: true,
        maxLength: 10,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    nationalId: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره ملی/ شناسه ملی",
      },
      validation: {
        required: true,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    telephone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "تلفن",
      },
      validation: {
        required: true,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    fax: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نمابر",
      },
      validation: {
        required: true,
        justNumber: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    address: {
      elementType: "input",
      elementConfig: {
        type: "textarea",
        placeholder: "آدرس",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    retrievePaymentLinkApi: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "لینک پرداخت",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    inquiryPaymentApi: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "api پرداخت",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    firstMileDiscount: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "درصد تخفیف هزینه باندل جمع آوری",
      },
      validation: {
        required: true,
        max: 100,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "0",
    },
    lastMileDiscount: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "درصد تخفیف هزینه باندل جمع آوری",
      },
      validation: {
        required: true,
        max: 100,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "0",
    },
  });

  React.useEffect(() => {
    if (props.edit) {
      const unt = unit;
      unt.unitName.value = props.unit.unitName;
      unt.retrievePaymentLinkApi.value = props.unit.retrievePaymentLinkApi;
      unt.inquiryPaymentApi.value = props.unit.inquiryPaymentApi;
      unt.economicalNumber.value = props.unit.economicalNumber;
      unt.registrationNumber.value = props.unit.registrationNumber;
      unt.postalcode.value = props.unit.postalcode;
      unt.nationalId.value = props.unit.nationalId;
      unt.telephone.value = props.unit.telephone;
      unt.fax.value = props.unit.fax;
      unt.address.value = props.unit.address;
      setEnableFirstMile(
        !!props.unit.enableFirstMile && props.unit.enableFirstMile === "1"
      );
      setEnableLastMile(
        !!props.unit.enableLastMile && props.unit.enableLastMile === "1"
      );
      unt.firstMileDiscount.value = props.unit.firstMileDiscount;
      unt.lastMileDiscount.value = props.unit.lastMileDiscount;
      setUnit(unt);
      if (props.unit.parentId != null) {
        const prnt = props.units.filter((u) => u.id == props.unit.parentId);
        if (prnt != null && prnt.length != 0) {
          setParent({
            value: prnt[0].id,
            label: prnt[0].unitName,
          });
        }
      }
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
      if (props.edit) {
        setId(props.unit.id);
      }
    }
  }, []);

  const changeUnit = (selectedOption) => {
    setParent(selectedOption);
    setInvalidSelect(false);
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(unit, {
      [controlName]: updateObject(unit[controlName], {
        value: !checkValidity(event.target.value, unit[controlName].validation)
          ? unit[controlName].value
          : event.target.value,
        valid: checkValidity(event.target.value, unit[controlName].validation),
        errorMessage: !checkValidity(
          event.target.value,
          unit[controlName].validation
        )
          ? "مقدار وارد شده صحیح نیست"
          : unit[controlName].errorMessage,
      }),
    });
    setUnit(updatedControls);
  };

  const insertUpdateUnit = (event) => {
    let valid = true;
    if (parent == null || parent == "") {
      valid = false;
      setInvalidSelect(true);
    }
    const unt = unit;
    for (let key in unt) {
      if (key == "postalcode" && unt[key].value.length < 10) {
        unt[key].valid = false;
        unt[key].errorMessage = "مقدار وارد شده صحیح نیست";
        valid = false;
      } else if (key == "nationalId") {
        const validNationalId =
          IsIRNationalCodeValid(unt[key].value) ||
          IsLegalNationalCodeValid(unt[key].value);
        if (!validNationalId) {
          unt[key].valid = false;
          unt[key].errorMessage = "مقدار وارد شده صحیح نیست";
          valid = false;
        }
      }
      if (!checkValidity(unt[key].value, unt[key].validation)) {
        unt[key].valid = false;
        valid = false;
      }
    }
    if (!valid) {
      setUnit(unt);
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      if (!edit) {
        setLoading(true);
        const unt = unit;
        var raw = JSON.stringify({
          unit: {
            parentId: parent != null && parent != "" ? parent.value : "",
            unitName: unt.unitName.value,
            economicalNumber: unt.economicalNumber.value,
            registrationNumber: unt.registrationNumber.value,
            postalcode: unt.postalcode.value,
            nationalId: unt.nationalId.value,
            telephone: unt.telephone.value,
            fax: unt.fax.value,
            address: unt.address.value,
            enableFirstMile: enableFirstMile ? "1" : "0",
            enableLastMile: enableLastMile ? "1" : "0",
            firstMileDiscount: unt.firstMileDiscount.value,
            lastMileDiscount: unt.lastMileDiscount.value,
            retrievePaymentLinkApi: unt.retrievePaymentLinkApi.value,
            inquiryPaymentApi: unt.inquiryPaymentApi.value,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/units/insertUnit";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewUnitForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      } else {
        setLoading(true);
        const unt = unit;
        var raw = JSON.stringify({
          unit: {
            id: id,
            parentId: parent != null && parent != "" ? parent.value : "",
            unitName: unt.unitName.value,
            economicalNumber: unt.economicalNumber.value,
            registrationNumber: unt.registrationNumber.value,
            postalcode: unt.postalcode.value,
            nationalId: unt.nationalId.value,
            telephone: unt.telephone.value,
            fax: unt.fax.value,
            address: unt.address.value,
            enableFirstMile: enableFirstMile ? "1" : "0",
            enableLastMile: enableLastMile ? "1" : "0",
            firstMileDiscount: unt.firstMileDiscount.value,
            lastMileDiscount: unt.lastMileDiscount.value,
            retrievePaymentLinkApi: unt.retrievePaymentLinkApi.value,
            inquiryPaymentApi: unt.inquiryPaymentApi.value,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/units/updateUnit";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewUnitForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      }
    }
  };

  let parentList = [];
  if (parents != null && parents.length != 0) {
    parents.map((z) => {
      parentList.push({
        value: z.id,
        label: z.unitName,
      });
    });
  }

  const formElementsArray = [];
  for (let key in unit) {
    formElementsArray.push({
      id: key,
      config: unit[key],
    });
  }

  let form = formElementsArray.map((formElement) => {
    let col = "6 mt-2";
    if (formElement.config.elementConfig.type == "textarea") {
      col = "12 mt-4";
    }
    if (formElement.id === "firstMileDiscount") {
      return (
        <>
          <div className="col-6">
            <FormControlLabel
              onChange={(event) => {
                setEnableFirstMile(!enableFirstMile);
              }}
              control={<Checkbox checked={enableFirstMile} />}
              label="باندل جمع آوری"
            />
          </div>
          <Input
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            placeholder={formElement.config.placeholder}
            errorMessage={formElement.config.errorMessage}
            search={true}
            col={col}
            changed={(event) => inputChangedHandler(event, formElement.id)}
          />
        </>
      );
    } else if (formElement.id === "lastMileDiscount") {
      return (
        <>
          <div className="col-6">
            <FormControlLabel
              onChange={(event) => {
                setEnableLastMile(!enableLastMile);
              }}
              control={<Checkbox checked={enableLastMile} />}
              label="باندل تخلیه"
            />
          </div>
          <Input
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            placeholder={formElement.config.placeholder}
            errorMessage={formElement.config.errorMessage}
            search={true}
            col={col}
            changed={(event) => inputChangedHandler(event, formElement.id)}
          />
        </>
      );
    } else {
      return (
        <Input
          key={formElement.id}
          elementType={formElement.config.elementType}
          elementConfig={formElement.config.elementConfig}
          value={formElement.config.value}
          invalid={!formElement.config.valid}
          shouldValidate={formElement.config.validation}
          placeholder={formElement.config.placeholder}
          errorMessage={formElement.config.errorMessage}
          search={true}
          col={col}
          changed={(event) => inputChangedHandler(event, formElement.id)}
        />
      );
    }
  });

  return (
    <Fade duration={200} left cascade>
      <div>
        <div className="row justify-content-center">
          <div className="unit-form-cntnr">
            <ContentForm headetText="حساب">
              <Select
                name="form-field-name"
                value={parent}
                placeholder="واحد ناظر"
                options={parentList}
                onChange={changeUnit}
                className={invalidSelect ? "invalid-select" : ""}
                col="6 mt-2"
              />
              {form}
              <div className="row w-100 justify-content-center mt-3">
                <div className="col-6 text-center">
                  <Button
                    btnType="Success"
                    clicked={(event) => props.toggleNewUnitForm(event, false)}
                  >
                    برگشت
                  </Button>
                </div>
                {!props.view ? (
                  <div className="col-6 text-center">
                    <Button btnType="Success" clicked={insertUpdateUnit}>
                      ثبت
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </ContentForm>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default UnitForm;
